















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import _ from 'lodash';

@Component
export default class AllyInputAutoComplete extends Vue {
	@Prop() private allyPlaceholder!: string;
	@Prop() private autoCompleteList!: any[];
	@Action private setInputText!: any;
	@Action private incrementActiveIdx!: any;
	@Action private decrementActiveIdx!: any;
	@Action private handleGoBack!: any;
	@Action private setAutoCompleteText!: any;
	@Action private resetAutoCompleteText!: any;
	@Action private updateActiveIdx!: any;
	@Action private closeAllyFromAlly!: any;
	@Action private clickEditButton!: any;
	@Action private updatePreview!: any;
	
	@State private storeInputText!: string;
	@State private autoCompleteText!: string;
	@State private previewState!: string;

	@Getter private activeName!: string;

	private created() {
		this.updatePreview();
	}

	@Watch('inputText')
	private updateInputText() {
		this.setInputText(this.inputText);
		// const that = this;
		// _.debounce(function() { 
		// 	console.log("does this work")
		// 	that.updatePreview(); 
		// }, 200);
		this.updatePreview(); 
	}

	private getCaretPosition(oField: any): number {
		let iCaretPos = 0;
		// @ts-ignore
		if (document.selection) {
			oField.focus();
			// @ts-ignore
			const oSel = document.selection.createRange();
			oSel.moveStart('character', -oField.value.length);
			iCaretPos = oSel.text.length;
		} else if (oField.selectionStart || oField.selectionStart === '0') {
			iCaretPos = oField.selectionStart;
		}

		// Return results
		return iCaretPos;
	}

	private maxAutoCompleteText(autoText: string) {
		const MAX_LENGTH = 55;
		if (autoText === null) { return ' '; }
		if (autoText.length > MAX_LENGTH) {
			return autoText.substr(0, MAX_LENGTH);
		}
		return autoText;
	}

	private getAutoCompleteText(autoCompleteText: string): string {
		if (autoCompleteText.toLowerCase().startsWith(this.inputText.toLowerCase())) {
			const sliceIdx = -1 * (autoCompleteText.length - this.inputText.length);
			if (sliceIdx === 0 ) {
				return;
			}
			if (this.inputText.length > 52) {
				return '';
			} else {
				return this.maxAutoCompleteText(this.inputText + autoCompleteText.slice(sliceIdx));
			}
		}
	}

	private handleKeyDown(e: any): void {
		if (e.key === 'Escape') {
			this.closeAllyFromAlly();
		} else if (e.key === 'Backspace' && this.inputText.length === 0) {
			this.handleGoBack();
		} else if ((e.key === 'Backspace' && this.inputText.length === 1)
			|| (e.key === 'Backspace' && e.metaKey)) {
			this.resetAutoCompleteText();
		} else if (e.key === 'Tab' || e.key === 'ArrowRight') {
			if (e.key === 'Tab') { e.preventDefault(); }
			
			const input = document.getElementById('ally-input-field');
			if (this.getCaretPosition(input) === this.inputText.length &&
				this.autoCompleteText_ !== '') {
				this.inputText = this.autoCompleteText_;
				this.resetAutoCompleteText();
			}
		} else if (e.key === 'e' && e.metaKey) {
			this.clickEditButton();
		}
	}


	private autocomplete(e: any): void {
		if (e.keyCode === 'ArrowUp' ||
			e.keyCode === 'ArrowRight' ||
			e.key === 'ArrowDown' ||
			e.key === 'Tab') {
			return;
		}

		if (this.inputText === '') {
			this.resetAutoCompleteText();
			return;
		}

		const foundOption = this.autoCompleteList.filter((listItem: any) => {
			return listItem.name.toLowerCase().startsWith(this.inputText.toLowerCase());
		});

		if (foundOption.length < 1) {
			this.resetAutoCompleteText();
			return;
		} else {
			// if we have found more than one flow
			const foundListItem = foundOption[0].name;

			this.autoCompleteText_ = this.getAutoCompleteText(foundListItem);
		}
	}

	private updateAutocompleteOnArrow() {
		if (this.inputText.length > 0 &&
			this.activeName.toLowerCase().startsWith(this.inputText.toLowerCase())) {
			this.autoCompleteText_ = this.getAutoCompleteText(this.activeName);
		} else {
			this.autoCompleteText_ = '';
		}
	}

	private async handleUpDown(e: any): Promise<any> {
		switch (e.key) {
			case 'ArrowUp': // if the UP key is pressed
				e.preventDefault();
				this.decrementActiveIdx();
				this.updateAutocompleteOnArrow();
				break;
			case 'ArrowDown': // if the DOWN key is pressed
				e.preventDefault();
				this.incrementActiveIdx();
				this.updateAutocompleteOnArrow();
				break;
	  }
	}

	get inputText() {
		return this.storeInputText;
	}
	set inputText(value) {
		this.updateActiveIdx(0);
		this.setInputText(value);
	}

	get autoCompleteText_() {
		return this.autoCompleteText;
	}
	set autoCompleteText_(value) {
		this.setAutoCompleteText(value);
	}
}
